if (!customElements.get('product-quickshop')) {
  class ProductQuickshop extends HTMLElement {
    constructor() {
      super();

      // Elements
      this.body = document.querySelector('body');
      this.productForm = document.querySelector('product-form');
      this.addToCartButton = document.querySelector('[data-add-to-cart-button]');
      this.quickshopAddToCartButton = this.querySelector('[data-quickshop-add-to-cart]');
      this.quickshopVariant = document.querySelector('[data-quickshop-variant]');
      if (!this.addToCartButton || !this.productForm) {
        return;
      }

      // Events
      this.quickshopAddToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.productForm.onSubmitHandler();
      });

      // Set right state on page load
      this.scrollAnimation(true);

      // scroll event
      this.raf = null; // Safe request animation frame
      this.timer = null; // Safe scroll timer
      window.addEventListener(
        'scroll',
        () => {
          clearTimeout(this.timer);
          if (!this.raf) {
            // A request animation frame is used to animate on max 60fps.
            this.raf = requestAnimationFrame(this.scrollAnimation.bind(this, false));
          }
          this.timer = setTimeout(() => {
            // Stop animation, cancel request animation frame
            cancelAnimationFrame(this.raf);
            this.raf = null;
          }, 100);
        },
        false
      );
    }

    scrollAnimation(init = false) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const buttonBounding = this.addToCartButton.getBoundingClientRect();
      const togglePosition = Math.round(buttonBounding.top + buttonBounding.height + scrollTop);

      if (scrollTop >= togglePosition) {
        this.classList.add('is-active');
        this.body.classList.add('quickshop-is-active');
      } else {
        this.classList.remove('is-active');
        this.body.classList.remove('quickshop-is-active');
      }

      this.currentScrollTop = scrollTop;

      // Recall request animation loop
      if (!init) {
        this.raf = requestAnimationFrame(this.scrollAnimation.bind(this, false));
      }
    }
  }

  window.ProductQuickshop = ProductQuickshop;
  customElements.define('product-quickshop', ProductQuickshop);
}
